import { nodeViewDecorator } from "./node-view-decorator.js";
import { FONT_FAMILY_TYPE } from "./types.js";
const pluginFontFamily = (config = {}) => {
  return {
    config,
    type: FONT_FAMILY_TYPE,
    nodeViewDecorators: [nodeViewDecorator(config.fallbackFontFamily)]
  };
};
export {
  pluginFontFamily
};
//# sourceMappingURL=viewer.js.map
